import React from 'react';
import {Menu, MenuItem, ProSidebar, SidebarContent, SidebarFooter, SidebarHeader, SubMenu} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import {Box, IconButton, Typography, useMediaQuery, useTheme} from "@mui/material";
import {useLocation} from "react-router-dom";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";


import Divider from "@mui/material/Divider";
import {useDispatch} from "react-redux";

import {ADMIN_INFO, IS_COLLAPSED} from "../../redux/action/type.action";
import './Sidebar.css';
import LogoutIcon from '@mui/icons-material/Logout';
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router";
import {sleep} from "../../tools/helper";
import {tokens} from "../../context/ThemeContext";
import {GetState, SetState} from '../../redux/reduxhelper'


import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import ContentPasteRoundedIcon from '@mui/icons-material/ContentPasteRounded';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import admin from "../../assets/images/admin/admin.png";


export default function Sidebar() {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation();

    // const fetchAccountInfo = async () => {
    //     try {
    //         if (!loggedIn) return false;
    //         const res = await getProfileInfoApi();
    //         dispatch(SetState(ADMIN_INFO, res?.data?.data))
    //
    //     } catch (e) {
    //
    //     }
    // }
    //
    const localData = GetState(ADMIN_INFO, {})
    //
    // useEffect(() => {
    //     fetchAccountInfo()
    // }, [loggedIn]);


    const theme = useTheme();
    const deviceIsLarge = useMediaQuery(theme.breakpoints.up('md'));

    const colors = tokens(theme.palette.mode);
    const DRAWER_IS_COLLAPSED = GetState(IS_COLLAPSED, !deviceIsLarge);

    const setIS_COLLAPSED = async (value) => {
        await dispatch(SetState(IS_COLLAPSED, value))
    }

    const Item = ({title, to, state, icon, disabled = false, index = false, pathNames = []}) => {
        let locationPathNames = location.pathname?.split('/');

        let active = false;
        pathNames?.forEach(pathName => {
            let slices = pathName.split('/');
            let isEqualCount = 0;
            slices.forEach((slice, index) => {
                if (slice === '*') {
                    isEqualCount++;
                    return true;
                }

                if (slice === locationPathNames[index] ?? null) {
                    isEqualCount++
                }
            });

            if (isEqualCount === slices.length) {
                active = true;
                return false;
            }
        });

        return (
            <MenuItem
                tabIndex={index ? 0 : -1}
                disabled={disabled}
                active={location.pathname === to || active}
                style={{
                    color: !disabled ? 'rgba(0, 0, 0, 1)' : '#dedede',
                }}
                onClick={!disabled ? async () => {

                    await setIS_COLLAPSED(!deviceIsLarge);
                    await sleep(200);
                    await navigate(to, {state})
                } : null}
                icon={icon}
            >
                <Typography>{title}</Typography>
            </MenuItem>
        );
    };


    const linkItems = [
        {
            title: 'ایونت اخیر',
            to: '/admin/dashboard/home',
            disabled: false,
            icon: <NotificationsNoneRoundedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/home/*']
        },
        {
            title: 'ایونت ها',
            to: '/admin/dashboard/events',
            disabled: false,
            icon: <CalendarMonthRoundedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/event/*']
        },
        {
            title: 'تیکت‌ ها',
            to: '/admin/dashboard/tickets',
            disabled: false,
            icon: <MailOutlineRoundedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/ticket/*']
        },
        {
            title: 'برنامه ها',
            to: '/admin/dashboard/programs',
            disabled: false,
            icon: <ContentPasteRoundedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/programs/*']
        },
        {
            title: 'مشتریان',
            to: '/admin/dashboard/customers',
            disabled: false,
            icon: <PeopleAltOutlinedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/customers/*']
        },
        {
            title: 'درباره ما',
            to: '/admin/dashboard/about-us',
            disabled: false,
            icon: <GridViewOutlinedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/about-us/*']
        },
        {
            title: 'هدف ما',
            to: '/admin/dashboard/our-target',
            disabled: false,
            icon: <DriveFileRenameOutlineOutlinedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/our-target/*']
        },
        {
            title: 'ثبت نام کنندگان',
            to: '/admin/dashboard/subscribers',
            disabled: false,
            icon: <SupportAgentRoundedIcon style={{color: "rgba(121, 121, 121, 0.6)"}}/>,
            before: null,
            after: null,
            style: {color: "green"},
            subs: [],
            path_names: ['/admin/dashboard/subscribers/*']
        },
    ]
    return (
        <>
            <Box id={'my_pro_sidebar'} sx={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                overflow: "hidden",
                height: {xs: '100%', md: 'calc(100% -78px)'},
                // "& .pro-sidebar": {
                //     width:'360px'
                // },
                "& .pro-sidebar.collapsed": {
                    width: {xs: '0px', md: '80px'},
                    minWidth: {xs: '0', md: '80px'}
                },
                "& .pro-sidebar-inner": {
                    background: `#ffffff`, //${colors.primary[500]}!important`,
                    fontFamily: "IRANSans, tahoma, roboto",
                },
                "& .pro-icon-wrapper": {
                    backgroundColor: "transparent !important"
                },
                "&. pro-inner-item": {
                    padding: "5px 35px 5px 20px !important"
                },
                "& .pro-inner-item:hover": {
                    color: "#868dfb !important"
                },
                "& .pro-menu-item.active": {
                    background: "rgba(89, 46, 169, 0.18)\n !important"
                }
            }}
            >

                <ProSidebar collapsed={DRAWER_IS_COLLAPSED} rtl={true}>
                    <SidebarHeader>
                        <Menu iconShape="square" onAbort={() => {
                            console.log('menu will collapsed')
                            setIS_COLLAPSED(true)
                        }}>
                            <Grid sx={{position: 'sticky', top: 0}}>
                                <MenuItem
                                    onClick={() => setIS_COLLAPSED(!DRAWER_IS_COLLAPSED)}
                                    icon={DRAWER_IS_COLLAPSED ? <MenuOutlinedIcon/> : undefined}
                                    style={{
                                        margin: "10px 0 20px 0",
                                        color: '#797979',
                                    }}
                                >

                                    {!DRAWER_IS_COLLAPSED && (
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            ml="15px"
                                        >
                                            <IconButton onClick={() => setIS_COLLAPSED(!DRAWER_IS_COLLAPSED)}>
                                                <ArrowForwardIcon style={{
                                                    // margin: "10px 0 20px 0",
                                                    color: '#797979',
                                                    direction: "ltr"
                                                }}/>
                                            </IconButton>
                                        </Box>
                                    )}
                                </MenuItem>
                            </Grid>

                            {!DRAWER_IS_COLLAPSED && (


                                <Box mb="25px">
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        {/*<IAvatar*/}
                                        {/*    alt="profile-user"*/}
                                        {/*    size={100}*/}
                                        {/*    src={localData?.avatar_thumb}*/}
                                        {/*    style={{*/}
                                        {/*        cursor: "pointer",*/}
                                        {/*        borderRadius: "50%",*/}
                                        {/*        border: "2px solid #eee",*/}
                                        {/*        objectFit: 'cover'*/}
                                        {/*    }}*/}
                                        {/*/>*/}

                                        <img
                                            alt="profile-user"
                                            width="70px"
                                            height="70px"
                                            // src={localData?.avatar}
                                            src={admin}
                                            style={{
                                                cursor: "pointer",
                                                borderRadius: "50%",
                                                border: "2px solid #eee"
                                            }}
                                        />

                                        <Typography
                                            variant="h6"
                                            color={colors.primary[800]}
                                            sx={{marginTop: "40px"}}
                                        >
                                            {/*{localData?.fullname}*/}
                                            مدیر
                                        </Typography>
                                        <Typography variant="h5" color={colors.primary[800]}>
                                            {/*{localData?.group_name}*/}
                                        </Typography>

                                    </Box>
                                    <Box textAlign="center">
                                        <Typography
                                            variant="h5"
                                            color={'#797979'}
                                            fontWeight="bold"
                                            sx={{marginTop: "10px"}}
                                        >
                                            {localData?.fullname}
                                        </Typography>
                                        <Typography variant={'subtitle2'}>
                                            {localData?.mobile}
                                        </Typography>
                                    </Box>
                                </Box>

                            )}
                        </Menu>
                    </SidebarHeader>

                    <SidebarContent>
                        <Divider/>
                        <Menu iconShape="square">
                            <Box>
                                {
                                    linkItems?.map((item, index) => {
                                        let subs = item?.subs;
                                        if (subs.length > 0) {
                                            return (
                                                <React.Fragment key={index}>
                                                    {item.before}
                                                    <SubMenu defaultOpen={location.pathname.startsWith(item?.to)}
                                                             title={item.title} icon={item.icon} style={item?.style}>
                                                        {subs?.map((sub, j) => (
                                                            <React.Fragment key={j}>
                                                                {sub.before}
                                                                <Item
                                                                    disabled={sub.disabled}
                                                                    title={sub.title}
                                                                    to={sub.to}
                                                                    state={sub?.state ?? {}}
                                                                    icon={sub.icon}
                                                                    style={sub?.style}
                                                                    pathNames={sub?.path_names}
                                                                />
                                                                {sub.after}
                                                            </React.Fragment>
                                                        ))}
                                                    </SubMenu>
                                                    {item.after}
                                                </React.Fragment>)
                                        }

                                        return (
                                            <Item
                                                key={index}
                                                disabled={item.disabled}
                                                title={item.title}
                                                state={item?.state ?? {}}
                                                to={item.to}
                                                icon={item.icon}
                                                pathNames={item?.path_names}
                                            />
                                        )

                                    })
                                }
                            </Box>
                        </Menu>
                    </SidebarContent>

                    <Divider/>

                    <SidebarFooter>
                        <Menu iconShape="square">
                            <MenuItem
                                style={{
                                    color: 'rgba(121, 121, 121, 1)' +
                                        ''
                                }}
                                onClick={() => {
                                    setIS_COLLAPSED(true)
                                    dispatch(SetState("LOGOUT_MODAL", true))
                                }}
                                icon={<LogoutIcon style={{color: 'rgba(121, 121, 121, 1)'}}/>}
                            >
                                <Typography>خروج</Typography>
                            </MenuItem>
                            <div style={{visibility: 'hidden', height: 24}}/>
                        </Menu>
                    </SidebarFooter>
                </ProSidebar>

            </Box>
        </>
    );
};

